import { Component, Input } from '@angular/core';
import { AbstractComponent } from '../../components/abstract-component/abstract.component';
import { ListLoader } from '../../components/list-loader/list-loader';
import { Router } from '@angular/router';
import { FormatConfigService } from '../../../core/services/format-config.service';
import { ComparatorService } from '../../services/comparator-service';
import { GrundstueckadresseDetailEntry } from '../../../core/av-api';
import { TableSortModel } from '../../tablesort/tableSortModel';
import { ErweiterungConfigResponse } from '../../../core/base-api';
import { ListLoaderWrapperComponent } from '../../components/list-loader-wrapper/list-loader-wrapper.component';
import { NgTemplateOutlet } from '@angular/common';
import { HistoryDirective } from '../../directives/history.directive';
import { KompaktTimepointComponent } from '../../kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { TranslatePipe } from '@ngx-translate/core';
import LagebezeichnungsTypEnum = GrundstueckadresseDetailEntry.LagebezeichnungsTypEnum;
import ActiveErweiterungenEnum = ErweiterungConfigResponse.ActiveErweiterungenEnum;

@Component({
  selector: 'cap-lagebezeichnung-table',
  templateUrl: './lagebezeichnung-table.component.html',
  imports: [ListLoaderWrapperComponent, NgTemplateOutlet, HistoryDirective, KompaktTimepointComponent, TranslatePipe]
})
export class LagebezeichnungTableComponent extends AbstractComponent {
  @Input()
  hasRight = true;

  private _listLoader: ListLoader<GrundstueckadresseDetailEntry>;
  private tableSortModel = new TableSortModel<GrundstueckadresseDetailEntry>('table', this.comparatorService);

  constructor(
    protected router: Router,
    protected appformatConfigService: FormatConfigService,
    protected comparatorService: ComparatorService
  ) {
    super();
    let isErweiterungAvPlusActive: boolean;
    this.addSub(
      this.appformatConfigService.erweiterungsConfig$.subscribe((erweiterungConfig) => {
        if (erweiterungConfig) {
          isErweiterungAvPlusActive = erweiterungConfig.activeErweiterungen.includes(ActiveErweiterungenEnum.AV_PLUS);
        }
      })
    );
    this.tableSortModel
      .addColumn('lagebezeichnung', (a, b) =>
        this.comparatorService.lagebezeichnungComparator(a, b, LagebezeichnungsTypEnum.FLURNAME, isErweiterungAvPlusActive)
      )
      .switchSortDirection();
  }

  @Input()
  set listLoader(listLoader: ListLoader<GrundstueckadresseDetailEntry>) {
    if (!listLoader) {
      return;
    }
    this._listLoader = listLoader;
    this._listLoader.applySortModel(this.tableSortModel);
  }

  get listLoader(): ListLoader<GrundstueckadresseDetailEntry> {
    return this._listLoader;
  }
}
